<template>
  <div class="container-fluid">
    <div id="brs" class="contents">
      <tab />
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <b-form @submit="onSubmit">
            <div class="row row-cols-2 row-cols-lg-4 g-2 mb-4">
              <div class="col-12 col-sm-6">
                <select
                  aria-label="search select"
                  v-model="searchData.searchtype"
                >
                  <option value="G.fit_goods_nm">
                    {{ $t("filter.brandroom.goods_name") }}
                  </option>
                  <option value="GS.fit_goods_shaft_nm">
                    {{ $t("filter.brandroom.club_name") }}
                  </option>
                  <option value="P.nickname">
                    {{ $t("filter.brandroom.nickname") }}
                  </option>
                  <option value="B.fit_brand_nm">
                    {{ $t("filter.brandroom.brand_name") }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-sm-6">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('text.common.enter_search_term')"
                    :aria-label="$t('text.common.enter_search_term')"
                    v-model="searchData.searchname"
                  />
                  <button
                    class="btn btn-primary btn-lg icon-search"
                    type="submit"
                  ></button>
                </div>
              </div>
              <div class="col">
                <select v-model="searchData.findex">
                  <option value="R.fit_buy_date" selected>
                    {{ $t("filter.brandroom.sort_by_order_date") }}
                  </option>
                  <option value="R.state_cd">
                    {{ $t("filter.brandroom.sort_by_status") }}
                  </option>
                  <option value="G.fit_goods_nm">
                    {{ $t("filter.brandroom.sort_by_goods_name") }}
                  </option>
                </select>
              </div>
              <div class="col">
                <select v-model="searchData.pagesize">
                  <option value="10">
                    {{ $t("filter.common.10perpage") }}
                  </option>
                  <option value="20">
                    {{ $t("filter.common.20perpage") }}
                  </option>
                  <option value="30">
                    {{ $t("filter.common.30perpage") }}
                  </option>
                </select>
              </div>
            </div>
          </b-form>
          <table class="table board">
            <thead>
              <tr>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.number") }}
                </th>
                <th class="col-auto d-lg-table-cell">
                  {{ $t("title.brandroom.goods_name") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.brandroom.club_infromation") }}
                </th>
                <th class="col-auto d-lg-table-cell w-1 text-center">
                  {{ $t("title.common.status") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.nickname") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.location") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.brandroom.order_date") }}
                </th>
                <th class="th-arrow">&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="total_cnt">
              <template v-for="(item, index) in items">
                <tr :key="index">
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.saleinfo.no }}
                  </td>
                  <td class="col-auto d-lg-table-cell text-start">
                    <router-link
                      :to="{
                        name: 'SaleView',
                        params: {
                          fitansno: item.saleinfo.fitansno,
                        },
                        query: { goodstype: searchData.goodstype },
                      }"
                    >
                      <p class="goods-kind">
                        {{ item.saleinfo.goodstype | get_club_type }}({{
                          item.saleinfo.clubtype_code_name
                        }})
                      </p>
                      <p class="goods-name">{{ item.saleinfo.goodsname }}</p>
                    </router-link>
                  </td>
                  <td class="col-auto d-none d-lg-table-cell text-start">
                    <router-link
                      :to="{
                        name: 'SaleView',
                        params: {
                          fitansno: item.saleinfo.fitansno,
                        },
                        query: { goodstype: searchData.goodstype },
                      }"
                    >
                      샤프트({{ item.saleinfo.shaftname }} /
                      {{ item.saleinfo.shaftmaterial | get_shaft_material }}
                      /
                      {{ item.saleinfo.shaftflextype | get_balance }})<br />
                      로프트 ({{ item.saleinfo.goodsloft || "-" }}) 라이각 ({{
                        item.saleinfo.goodslie || "-"
                      }}) 솔 ({{ item.saleinfo.goodssole || "-" }}) FP ({{
                        item.saleinfo.goodsfp || "-"
                      }}) 길이 ({{ item.saleinfo.goodslength || "-" }}) 총무게
                      ({{ item.saleinfo.goodsweight || "-" }})
                    </router-link>
                  </td>
                  <td class="col-auto d-lg-table-cell">
                    <button
                      class="btn btn-xs w-100 text-center"
                      :class="[
                        {
                          'bg-orange text-white':
                            item.saleinfo.fittingstatus == '1',
                        },
                        {
                          'bg-green text-white':
                            item.saleinfo.fittingstatus == '2',
                        },
                        {
                          'bg-secondary bg-opacity-50 text-white':
                            item.saleinfo.fittingstatus == '3',
                        },
                      ]"
                      type="button"
                      @click="onClickRedirect(item)"
                    >
                      {{ item.saleinfo.fittingstatus | get_state_cd }}
                    </button>
                  </td>
                  <td class="col-auto d-none d-lg-table-cell date">
                    <MemberInfo
                      :nickname="item.saleinfo.nickname"
                      :playerno="item.saleinfo.memberno"
                    />
                  </td>
                  <td class="col-auto d-none d-lg-table-cell shop-name">
                    {{ item.saleinfo.shopname }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell text-date">
                    {{ item.saleinfo.orderdate }}
                  </td>
                  <td class="td-arrow" @click="toggle_tr(index)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="col-auto d-lg-none d-md-tabel-cell"
                  :class="{ show: view_hide === index }"
                  :key="index + 'r'"
                  v-if="view_hide === index"
                >
                  <td colspan="7">
                    <div class="toggle-content">
                      <div class="row">
                        <div class="col-4">{{ $t("title.common.number") }}</div>
                        <div class="col-8">
                          {{ item.saleinfo.no }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.brandroom.club_infromation") }}
                        </div>
                        <div class="col-8">
                          <router-link
                            :to="{
                              name: 'SaleView',
                              params: {
                                fitansno: item.saleinfo.fitansno,
                              },
                              query: { goodstype: searchData.goodstype },
                            }"
                          >
                            샤프트({{ item.saleinfo.shaftname }} /
                            {{
                              item.saleinfo.shaftmaterial | get_shaft_material
                            }}
                            /
                            {{
                              item.saleinfo.shaftflextype | get_balance
                            }})<br />
                            로프트 ({{ item.saleinfo.goodsloft || "-" }}) 라이각
                            ({{ item.saleinfo.goodslie || "-" }}) 솔 ({{
                              item.saleinfo.goodssole || "-"
                            }}) FP ({{ item.saleinfo.goodsfp || "-" }}) 길이 ({{
                              item.saleinfo.goodslength || "-"
                            }}) 총무게 ({{ item.saleinfo.goodsweight || "-" }})
                          </router-link>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.common.nickname") }}
                        </div>
                        <div class="col-8">
                          <MemberInfo
                            :nickname="item.saleinfo.nickname"
                            :playerno="item.saleinfo.memberno"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.common.location") }}
                        </div>
                        <div class="col-8 shop-name">
                          {{ item.saleinfo.shopname }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.brandroom.order_date") }}
                        </div>
                        <div class="col-8 text-date">
                          {{ item.saleinfo.orderdate }}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label="Pagination"
            class="mt-3"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text>
              <i class="material-icons">keyboard_double_arrow_left</i>
            </template>
            <template #prev-text>
              <i class="material-icons">navigate_before</i>
            </template>
            <template #next-text>
              <i class="material-icons">navigate_next</i>
            </template>
            <template #last-text>
              <i class="material-icons">keyboard_double_arrow_right</i>
            </template>
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import tab from "@/components/fitting/SaleListTab";
import ax from "@/api/fitting";
import "@/filter/common";

export default {
  name: "FittingSaleList",
  components: {
    location,
    tab,
  },
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "G.fit_goods_nm",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        goodstype:
          this.$route.query.goodstype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].goodstype) ||
          0,
        brandno:
          (this.$store.state.admin && this.$store.state.admin.brandno) || 0,
        findex: "R.fit_buy_date",
        pagesize: "10",
      },

      page_total: 1,
      total_cnt: 0,
      rows: 10,
      items: [],
      view_hide: null,
      deliverySendData: { info: {}, shiplist: [] },
    };
  },
  methods: {
    onClickRedirect: function (item) {
      if (item.saleinfo.ship_url && item.saleinfo.ship_invoice_no)
        window.open(
          item.saleinfo.ship_url + item.saleinfo.ship_invoice_no,
          "_blank"
        );
      return false;
    },
    get_salelist() {
      (this.searchData.goodstype =
        this.$route.query.goodstype ||
        (this.$store.state.searchData[this.$route.name] &&
          this.$store.state.searchData[this.$route.name].goodstype) ||
        0),
        this.$store.commit("setSearchData", {
          [this.$route.name]: this.searchData,
        });

      ax.get_salelist(this.searchData, (flag, data = "") => {
        this.total_cnt = data.pagination.salelistcnt;
        this.page_total = Math.ceil(
          data.pagination.salelistcnt / this.searchData.pagesize
        );
        this.items = data.salelist;
        if (!flag) alert(data.message);
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_salelist();
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },

    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },

    confirm() {
      if (
        !this.deliverySendData.info.ship_no ||
        this.deliverySendData.info.ship_no === "0"
      ) {
        alert(this.$i18n.t("alert.fitting.select_delivery_company"));
        return false;
      }

      if (this.deliverySendData.info.ship_invoice_no === "") {
        alert(this.$i18n.t("alert.fitting.enter_invoice_number"));
        return false;
      }

      ax.post_deliverywrite(this.deliverySendData.info, (flag, data) => {
        alert(data.message);
        if (flag) {
          this.$refs["settingModal"].hide();
          this.deliverySendData = { info: {}, shiplist: [] };
        }
      });
    },
  },
  created() {
    console.log("this.searchdata", this.searchData);
    this.get_salelist();
  },
  watch: {
    "$route.query": function () {
      this.searchData.pageno = parseInt(this.$route.query.page) || 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_salelist();
    },

    "searchData.findex": function () {
      this.get_salelist();
    },
    "searchData.pagesize": function () {
      this.get_salelist();
    },
  },
};
</script>
